const o=(o,n=" ")=>o.join(n);export{o as convertArrayToString};
